import { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/Logo-Protean.svg';
import { getUserData } from '../_actions';
import Dropdown from '../components/dropdown';
import NotificationWindow from '../components/NotificationWindow';
import { hideAdmin, getFirstEntry, canSeeMobileApp, isAdmin } from '../helpers/utils';
// import config from '../_config/config';

const NavbarBrand = () => (
  <div className="navbar-brand custom-header-logo protean-logo-block">
    <Link to={getFirstEntry()} className="d-inline-block">
      <img src={logo} alt="" />
    </Link>
  </div>
);

const NavbarMobileButtons = () => (
  <div className="d-md-none">
    <button
      className="navbar-toggler collapsed"
      type="button"
      onClick={() => document.getElementById('navbar-mobile').classList.toggle('show')}
    >
      <i className="icon-tree5" />
    </button>
    <button
      onClick={() => document.body.classList.toggle('sidebar-mobile-main')}
      className="navbar-toggler sidebar-mobile-main-toggle"
      type="button"
    >
      <i className="icon-paragraph-justify3" />
    </button>
  </div>
);

const Navbar = () => {
  document.body.classList.add('sidebar-xs');
  const user = useMemo(() => getUserData(), []);
  const showApp = useMemo(
    () => canSeeMobileApp(user) && window.location.host === 'proteanapp.com',
    [user]
  );
  const showCaches = useMemo(() => isAdmin(user), [user]);

  return (
    <div className="navbar navbar-expand-md navbar-dark protean-navbar">
      <NavbarBrand />
      <NavbarMobileButtons />
      <div className="collapse navbar-collapse" id="navbar-mobile">
        <ul className="navbar-nav ml-auto">
          <NotificationWindow title="Comments" />
          <NotificationWindow title="Alerts" />
          <li className="nav-item">
            <Dropdown
              className=""
              title={user.current_user && user.current_user.name}
              toggleClassName="navbar-nav-link d-flex align-items-center button-title"
              rightOrientation
            >
              <Dropdown.Item icon="icon-switch2" as={Link} to="/logout">
                Logout
              </Dropdown.Item>
              {showCaches && (
                <Dropdown.Item icon="icon-tree5" as={Link} to="/update_caches">
                  Update user caches
                </Dropdown.Item>
              )}
              {showCaches && (
                <Dropdown.Item icon="icon-tree5" as={Link} to="/jobs">
                  Jobs monitoring
                </Dropdown.Item>
              )}

              {showApp && (
                <Dropdown.Item icon="fa fa-window-restore">
                  <a
                    className="link_as_text"
                    href="https://apps.apple.com/ua/app/prote%C3%A4n/id1556719769"
                  >
                    Install proteän
                  </a>
                </Dropdown.Item>
              )}
              {!hideAdmin(user) && (
                <Dropdown.Item icon="fa fa-cogs" onClick={() => window.open('/admin')}>
                  Admin Panel
                </Dropdown.Item>
              )}
            </Dropdown>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default memo(Navbar);
